export const IMAGES = {
  hero: "/img/robot_hero.png",
  card: "/img/robot_card.png",
  review: "/img/robot_review.png",
  thumbs: "/img/robot_thumbs.png",
  lab: "https://static.prod-images.emergentagent.com/jobs/071224ed-bd37-420a-b5b1-20d4b4353429/images/d93cbe08386ae06bfec7fbac5747614131138d0cd84aba6945c9c18f90ecbd4d.jpeg",
};
